// extracted by mini-css-extract-plugin
module.exports = {"checkboxField":"checkbox-field-module--checkboxField--3XUW-","checkbox":"checkbox-field-module--checkbox--2aHy6","label":"checkbox-field-module--label--3WSNP"};